import { type Meta } from '../types/docs';
import { ONBOARDING_ANALYTICS_CATEGORY_META_PARAM } from './onboardingAnalytics';

const META: Meta = {
  description: 'Event sent when a user submits their name during onboarding',
  name: 'Completed onboarding basic info',
  params: [
    {
      description: 'Account email',
      name: 'email',
      required: true,
      type: 'string',
    },
    {
      description: 'Account first name',
      name: 'firstName',
      required: true,
      type: 'string',
    },
    {
      description: 'Account last name',
      name: 'lastName',
      required: true,
      type: 'string',
    },
    ONBOARDING_ANALYTICS_CATEGORY_META_PARAM,
  ],
};

export default META;
